/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Reload_HintInputs */

const es_pwa_reload_hint = /** @type {(inputs: Pwa_Reload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacé clic en recargar para actualizar.`)
};

const en_pwa_reload_hint = /** @type {(inputs: Pwa_Reload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click reload to update.`)
};

/**
* | output |
* | --- |
* | "Click reload to update." |
*
* @param {Pwa_Reload_HintInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const pwa_reload_hint = /** @type {((inputs?: Pwa_Reload_HintInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Reload_HintInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pwa_reload_hint(inputs)
	return en_pwa_reload_hint(inputs)
});
export { pwa_reload_hint as "pwa.reload_hint" }